<template>
  <div>
    <div class="container" :class="{ disableContainer: isOpen }" @click="handleNavOpen(isOpen)">
      <div class="logo__menu pad20" :class="{ disableLogo: isOpen }" @click.stop>
        <router-link to="/">
          <img class="navigation__logo" :src="require('@/assets/dver-logo.svg')" />
        </router-link>
      </div>

      <div v-if="!isOpen" class="menu__icon">
        <img :src="menuIconSrc" />
      </div>
    </div>

    <nav v-if="isOpen" class="menu" aria-label="navigation" :class="{ openNav: isOpen }">
      <div class="menu__icon__open">
        <img :src="menuIconSrc" @click="handleNavClose" />
      </div>
      <router-link to="/">
        <img class="logo" :src="require('@/assets/dver-logo.svg')" />
      </router-link>

      <div class="align-center">
        <user-info-card v-if="isAuth" :userInfo="userInfo" :memberType="memberType" @click="handleNavClick(myURL)" />
        <login-signup-buttons v-else @login="handleNavClick(loginURL)" @signup="handleNavClick(singUpURL)" />

        <hr />
      </div>
      <div class="nav__list" v-for="item in list" :key="item.path">
        <nav-list :item="item" :userType="userType"></nav-list>
      </div>

      <div class="mobile__action">
        <div v-show="isAuth" class="align-center">
          <CCard
            singleText
            useSingleTextCenter
            content="로그아웃"
            width="260px"
            height="50px"
            pointer
            fontColor="g700"
            backgroundColor="white"
            @button-click="
              signout();
              isOpen = false;
            "
          />
        </div>
      </div>
    </nav>
  </div>
</template>

<script>
import navList from "./navList.vue";
import CCard from "@/components/common/CCard/CCard.vue";
import UserInfoCard from "./UserInfoCard.vue";
import LoginSignupButtons from "./LoginSignupButtons.vue";

export default {
  components: { navList, CCard, UserInfoCard, LoginSignupButtons },
  props: ["list", "isAuth", "userType", "signout"],
  data() {
    return {
      isOpen: false,
      loginURL: "/users/signin",
      singUpURL: "/join/intro",
      myURL: "/my/info",
      userInfo: {
        name: "",
        companyName: "",
      },
    };
  },
  computed: {
    isAuthenticated() {
      return this.$store.getters["auth/isAuthenticated"]();
    },
    menuIconSrc() {
      return this.isOpen ? require("@/assets/img/navi_cancle.png") : require("@/assets/img/navi_menu.png");
    },
    userTypeInfo() {
      return this.$store.getters["auth/tokenPayload"]().type;
    },
    memberType() {
      const type = this.userTypeInfo;

      switch (type) {
        case "member":
          return { label: "구성원", color: "#19B8A5" };
        case "manager":
          return { label: "관리자", color: "#0077EB" };
        default:
          return "ERROR";
      }
    },
  },
  watch: {
    isAuthenticated: {
      immediate: true,
      handler(newValue) {
        if (newValue) {
          this.setInfo();
        }
      },
    },
  },
  created() {
    const vm = this;
    this.$router.afterEach((to, from) => {
      vm.isOpen = false;
      document.body.classList.remove("modal-open");
    });
  },
  methods: {
    handleNavOpen(isOpen) {
      this.isOpen = !isOpen;
      document.body.classList.toggle("modal-open", this.isOpen);
    },
    handleNavClose() {
      this.isOpen = false;
      document.body.classList.remove("modal-open");
    },
    handleNavClick(path) {
      if (this.$route.path !== path) {
        this.$router.push(path);
      }
    },
    async setInfo() {
      if (!this.isAuthenticated) {
        return;
      }
      try {
        const api = this.userTypeInfo === "member" ? "users/biz_member_myInfo" : "users/biz_manager_myInfo";

        const { success, information } = await this.$store.dispatch(api);

        if (success && information) {
          this.userInfo = {
            name: information.name,
            companyName: information.vatInfo?.companyName,
          };
        }
      } catch (error) {
        await this.$store.dispatch("auth/signout");
        this.$router.push("/");
      }
    },
  },

  mounted() {
    this.setInfo();
  },
};
</script>

<style scoped>
.container {
  display: flex;
  height: 64px;
}
.disableContainer {
  width: calc(100% - 320px);
  background-color: #00000080;
  height: 100vh;
  position: absolute;
  overflow: hidden;
}
.menu__icon {
  width: 100px;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding-right: 20px;
}
.menu__icon img {
  width: 24px;
  height: 24px;
}
.menu__icon__open {
  width: 100%;
  height: 56px;
  background-color: white;
  position: sticky;
  top: 0px;
  display: flex;
  justify-content: right;
  align-items: center;
}
.menu__icon__open img {
  width: 24px;
  height: 24px;
  padding-right: 20px;
  filter: brightness(0) saturate(100%) invert(80%) sepia(14%) saturate(239%) hue-rotate(169deg) brightness(95%)
    contrast(85%);
}
.drawer__button {
  width: 320px;
  right: 0;
  position: fixed;
  height: 56px;
  background-color: var(--white);
  z-index: 1000;
}
.drawer__button img {
  width: 24px;
  height: 24px;
  filter: brightness(0) saturate(100%) invert(80%) sepia(14%) saturate(239%) hue-rotate(169deg) brightness(95%)
    contrast(85%);
  float: right;
  padding: 16px 30px 16px;
}
.disableLogo {
  opacity: 0.33;
  pointer-events: none !important;
}
.navigation__logo {
  cursor: pointer;
}
.menu {
  width: 100%;
  height: 100vh;
  padding: 0 0 200px;
  box-sizing: border-box;
  max-width: 320px;
  right: 0;
  position: absolute;
}
.nav__list {
  padding: 0 20px;
}
.logo {
  display: block;
  width: 78.75px;
  height: 30px;
  gap: 0px;
  margin: 0 auto 24px;
}
.mobile__action {
  padding-top: 6px;
}
.logo__menu {
  display: inline-block;
  width: 100%;
}
.openNav {
  background-color: var(--white);
  transition: background-color 0.3s ease;
  height: calc(100vh + 20px);
  overflow-y: auto;
  -ms-overflow-style: none;
}
.openNav::-webkit-scrollbar {
  display: none;
}
.align-center {
  display: grid;
  place-items: center;
}
hr {
  width: 260px;
  border: 1px solid var(--gray-200);
  margin-top: 24px;
}
.pad20 {
  padding: 20px;
}
</style>
